document.addEventListener('DOMContentLoaded', () => {

  const observer = new MutationObserver((mutations, obs) => {
    const needsclickHost = document.querySelector('#axeptio_overlay > div.needsclick');

    if (needsclickHost && needsclickHost.shadowRoot) {

      const innerObserver = new MutationObserver(() => {
        const discardButton = needsclickHost.shadowRoot.querySelector('.ax-discardButton');
        if (discardButton) {
          discardButton.style.setProperty('display', 'none');
        }

          if (discardButton) {
              clearTimeout(timeoutId);
              innerObserver.disconnect();
          }

      });

      innerObserver.observe(needsclickHost.shadowRoot, { childList: true, subtree: true });

      obs.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  timeoutId = setTimeout(() => {
    observer.disconnect();
    console.warn("⛔️ Timeout : Axeptio non détecté dans le DOM.");
  }, 10000);
});